// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__13ybF","title":"ClientReferral_title__3acVs","itemText":"ClientReferral_itemText__1NUAU"};